import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE, withCredentials: false });

const TOKEN_KEY = "oer_admin_token";

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

/** Convert relative upload paths to full URL */
export function mediaUrl(path) {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  // Persistent GridFS media (current) + backend-routed uploads
  if (path.startsWith("/api/media") || path.startsWith("/api/uploads")) return `${BACKEND_URL}${path}`;
  // Legacy paths stored as /uploads -> remap to /api/uploads
  if (path.startsWith("/uploads")) return `${BACKEND_URL}/api${path}`;
  return path;
}

/** Format ZAR price */
export function formatZar(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  if (Number.isNaN(n)) return `R${value}`;
  return `R${n.toLocaleString("en-ZA")}`;
}

export default api;
